// plan-02 S06: mute coordination + status bar affordance — bible S18

import { resumeOnGesture, setMasterMuted } from './context'
import { startDrone } from './drone'
import { setSfxMuted } from './sfx'
import { load, set } from '../core/save'

let audioActive = false

function isMuted(): boolean {
  return load().audioMuted
}

export function setMuted(muted: boolean): void {
  set('audioMuted', muted)
  setSfxMuted(muted)
  setMasterMuted(muted)
  updateBar()
}

export function isAudioActive(): boolean {
  return audioActive
}

async function activate(): Promise<void> {
  if (audioActive) return
  audioActive = true
  await resumeOnGesture()
  startDrone()
  // if user previously muted, silence the drone immediately
  if (isMuted()) {
    setMasterMuted(true)
  }
  updateBar()
}

function updateBar(): void {
  const bar = document.getElementById('vt-audio-toggle')
  if (!bar) return
  bar.textContent = isMuted() ? '[ unmute ]' : '[ mute ]'
}

export function mountMuteAffordance(parent: HTMLElement): void {
  const toggle = document.createElement('span')
  toggle.id = 'vt-audio-toggle'
  toggle.setAttribute('role', 'button')
  toggle.setAttribute('tabindex', '0')
  toggle.setAttribute('aria-label', 'toggle audio mute')
  toggle.style.cssText = 'cursor:pointer;color:var(--vt-green-dim);user-select:none;'
  toggle.textContent = isMuted() ? '[ unmute ]' : '[ mute ]'

  toggle.addEventListener('click', () => {
    if (!audioActive) return // capture-phase auto-activate handles this
    const s = load()
    setMuted(!s.audioMuted)
  })

  toggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggle.click()
    }
  })

  parent.appendChild(toggle)

  // Auto-activate audio on first page interaction.
  // Capture phase fires BEFORE the toggle's click handler, so audioActive
  // is set synchronously before the toggle tries to read it.
  const autoActivate = async () => {
    if (!audioActive) await activate()
  }
  document.addEventListener('click', autoActivate, { capture: true, once: true })
  document.addEventListener('keydown', autoActivate, { capture: true, once: true })
}
